<template>
  <div style="position: relative; margin-top: 0px; box-sizing: border-box">
    <div class="hello">
      <el-carousel
        height="150px"
        :interval="100000"
        trigger="click"
        arrow="always"
        @change="projectPlayChange"
      >
        <el-carousel-item v-for="(item, i) in items" :key="i">
          <div style="position: relative">
            <img
              style="position: relative; left: -150px"
              :src="item.img"
              alt=""
            />
            <div class="con6">
              <!-- <img
                style="width: 648px; height: 256px"
                src="../assets/official/Group 47996@2x.png"
                alt=""
              /> -->
              <div class="content" style="padding-top: 20px">
                <div
                  style="
                    font-size: 42px;
                    color: #000;
                    margin-top: 0px;
                    font-weight: bold;
                  "
                >
                  {{ item.title }}
                </div>
                <div style="font-size: 42px; color: #000; font-weight: bold">
                  {{ item.titleTwo }}
                </div>
                <div
                  style="
                    font-size: 18px;
                    margin-top: 30px;
                    color: rgba(128, 128, 128, 1);
                    color: #747474;
                  "
                >
                  {{ item.text }}
                </div>
                <div
                  style="
                    margin-top: 8px;
                    font-size: 18px;
                    color: rgba(128, 128, 128, 1);
                    margin-bottom: 70px;
                    color: #747474;
                  "
                >
                  {{ item.textTwo }}
                </div>
                <div
                  @click="inquiry()"
                  style="
                    height: 48px;
                    width: 188px;
                    background: linear-gradient(to right, #03a0fc, #0274f7);
                    text-align: center;
                    line-height: 48px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 1);
                    margin-bottom: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                  "
                >
                  立即免费体验
                  <i
                    style="
                      line-height: 48px;
                      margin-left: 10px;
                      margin-top: 2px;
                    "
                    class="el-icon-right"
                  ></i>
                  <!-- <img
                    style="width: 16px; height: 16px; margin-left: 10px"
                    src="../assets/official/Frame 16@2x.png"
                    alt=""
                  /> -->
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      v-if="bademon"
      style="
        position: fixed;
        top: 0px;
        left: 0;
        z-index: 2001;
        height: 100vh;
        width: 100vw;
        background-color: rgba(204, 204, 204, 0.7);
      "
    ></div>
    <div
      v-if="bademon"
      style="
        width: 346px;
        height: 320px;
        background-color: #fff;
        position: fixed;
        top: 30%;
        left: calc(50% - 173px);
        z-index: 2002;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;
      "
    >
      <i
        class="el-icon-close"
        style="position: absolute; top: 10px; right: 10px"
        @click="unInquiry()"
      ></i>
      <div
        style="font-size: 20px; color: rgba(51, 51, 51, 1); font-weight: 500"
      >
        免费定制专属网校
      </div>
      <el-select
        v-model="value"
        placeholder="请选择您所在的行业"
        style="height: 40px; width: 270px; margin: 24px 0 16px 0"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请输入您的联系方式"
        style="height: 40px; width: 270px"
      ></el-input>
      <div
        style="
          height: 40px;
          width: 270px;
          font-size: 14px;
          color: #0274f7;
          margin: 10px 0 20px 0;
        "
      >
        提交即可获取30天免费试用
      </div>
      <el-button
        @click="submitPhone"
        type="primary"
        style="
          height: 40px;
          width: 270px;
          background-color: #0274f7;
          color: #fff;
        "
        >提交</el-button
      >
    </div>
    <Dialog :visible.sync="visible" @update:visible="visible = $event">
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/components/diolog.vue'
import { add, getIndustryList } from '../api/util'
import { report } from '@/js/utils'
import axios from 'axios'

export default {
  name: 'lunbo',
  components: {
    Dialog,
  },
  data() {
    return {
      bademon: false,
      options: [
        {
          value: '知识付费',
          label: '知识付费',
        },
        {
          value: '兴趣培训',
          label: '兴趣培训',
        },
        {
          value: '大健康',
          label: '大健康',
        },
        {
          value: 'K12教育',
          label: 'K12教育',
        },
        {
          value: '企业培训',
          label: '企业培训',
        },
        {
          value: '医疗美容',
          label: '医疗美容',
        },
      ],
      value: '',
      input: '',
      value1: '',
      dialogVisible: false,
      input1: '',
      schooList: [],
      yanzheng: false,
      yanzheng2: false,
      visible: false,
      items: [
        {
          img: require('../assets/official/1.jpg'),
          title: '全场景私域运营',
          titleTwo: '助力数字化、自动化升级',
          text: '构建私域闭环，降低退费率，提升ROI',
          textTwo: '赋能运营团队高人效、精细化，实现利润持续增长',
        },
        {
          img: require('../assets/official/111.jpg'),
          title: '全链路数据驱动',
          titleTwo: '提供一站式私域运营工具',
          text: '私域工具+运营服务双向加持',
          textTwo: '让企业成长可持续，成功模式可复制',
        },
        {
          img: require('../assets/official/3(1).jpg'),
          title: '全行业私域解决方案',
          titleTwo: '好产品经得起市场、客户验证',
          text: '服务行业涉及知识付费、大健康、K12、国学、医美等15+行业',
          textTwo: '共计签约近10000+家客户，触达终端用户2亿+人次',
        },
      ],
    }
  },
  mounted() {
    this.getIndustryListTop()
  },
  methods: {
    //提交留资信息
    submitPhone() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (this.input && this.value && ccc.test(this.input)) {
        axios
          .get(
            'https://manager-api.mischool.com.cn' +
              '/official/mail?' +
              'mobile=' +
              this.input +
              '&industry=' +
              this.value
          )
          .then((res) => {
            if (res.data.code === 200) {
              console.log('发送成功')
              this.bademon = false
              this.$message.success('提交成功')
              this.input = ''
              this.value = ''
            }
          })
      } else {
        this.$message.error('请选择行业或输入手机号')
      }
    },
    // 打开留资弹窗
    inquiry() {
      console.log('我点击了')
      this.bademon = true
    },
    // 关闭留资弹窗
    unInquiry() {
      this.bademon = false
    },
    ddss() {
      let f = '首页->轮播图->立即咨询'
      report(false, f)
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    // 轮播图自动播放事件
    projectPlayChange() {
      this.input1 = ''
      this.yanzheng = false
    },
    getIndustryListTop() {
      let that = this
      getIndustryList().then((res) => {
        let arr = []
        for (let i in res.data.data) {
          arr.push(res.data.data[i])
        }
        arr.map((item, index) => {
          that.schooList.push({ label: item.title, value: item.id })
        })
      })
    },
    // 手机号验证
    dianhuan() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      // if (!(ccc.test(this.input))) {
      //    // console.log("手机号码输入不规范");
      //   this.yanzheng=true
      // }else if(!this.value){
      //   this.yanzheng2=true
      // }else{
      //     console.log("手机号码输入规范");
      //     this.yanzheng=false
      //     let data ={
      //       phone:this.input,
      //       industryId:this.value
      //     }
      //     add(data).then(res=>{
      //         console.log(res);
      //     })
      // }
      if (!this.value1) {
        this.yanzheng2 = true
      } else if (!ccc.test(this.input1)) {
        this.yanzheng2 = false
        this.yanzheng = true
      } else {
        this.yanzheng = false
        let data = {
          phone: this.input1,
          industryId: this.value1,
          uuid: this.$getItem('result'),
        }
        add(data).then((res) => {
          if (res.data.code == 200) {
            this.dialogVisible = true
            this.value1 = ''
            this.input1 = ''
          }
          console.log(res)
        })
      }
    },
    getSchool() {
      var that = this
      let data = {
        groupCode: 'EDUCATION',
      }
      getDictMap(data).then((res) => {
        let arr = []
        for (let i in res.data.data) {
          arr.push(res.data.data[i])
        }
        arr.map((item, index) => {
          that.schooList.push({ label: item, value: index + 1 })
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: left;
  align-items: start;
  flex-direction: column;
}
::v-deep .el-link.el-link--default:hover {
  color: #fff;
  font-size: 16px;
}
::v-deep .el-link.el-link--default {
  color: #fff;
  font-size: 16px;
}
.asdf ::v-deep .el-dialog {
  width: 470px !important;
  height: 320px !important;
  border-radius: 8px;
}

.asdf ::v-deep .el-dialog__header {
  display: none;
}

.asdf ::v-deep .el-dialog__body {
  text-align: center;
  padding: 0;
}

.asdf .xxx_top {
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: #eb5b05;
  margin-bottom: 12px;
}

.asdf .xxx_topy {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  margin-bottom: 16px;
}

.asdf .xxx_topu {
  display: flex;
  justify-content: center;
  height: 40px;
}

.asdf .xxx_topu22 {
  width: 270px;
  height: 40px !important;
  background: #eb5b05;
  border-radius: 4px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  color: #ffffff;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #ee1c46;
}

::v-deep .el-select .el-input__inner:focus {
  border-color: #ee1c46;
}

.con6 {
  cursor: pointer !important;
  width: 800px;
  height: 256px;
  opacity: 1;
  color: #ffffff;
  // background: rgb(255, 255, 255);
  position: absolute;
  left: 2400px;
  top: 200px;
  z-index: 99;
  display: flex;
  // justify-content: center;
  align-items: center;
}

.boss_1 {
  width: 346px;
  height: 320px;
  border-radius: 10px;
  background: rgb(255, 255, 255);
  position: absolute;
  left: 2757px;
  top: 136px;
  z-index: 99;
  /* padding: 30px 36px 0; */
}

.boss_2 {
  color: #000;
  font-size: 20px;
  font-weight: 00;
  height: 28px;
  margin-top: 20px;
  // line-height: 30px;
  text-align: center;
}

.boss_3 {
  align-items: center;
  color: #666666;
  /* -ms-flex-direction: row; */
  flex-direction: row;
  font-size: 16px;
  height: 22px;
  display: flex;
  justify-content: center;
  margin-top: 8px;

  .boss_31 {
    background: #0075ff;
    border-radius: 4px;
    color: #fb6904;
    font-size: 16px;
    font-weight: 500;
    margin: 0 7px;
    padding: 3px 7px;

    &.active {
      background: #fff0e8;
      color: #eb5b05;
    }

    &.active1 {
      background: #e3ecff;
      color: #2e6bec;
    }

    &.active2 {
      background: #e2e3ff;
      color: #595dea;
    }
  }
}

.errortext1111 {
  color: #ee1c46;
  font-size: 14px;
  height: 21px;
  line-height: 21px;
  margin: 0 36px;
}

.boss_4 {
  margin: 0 36px;

  //  height: 82px;
  .errortext {
    color: #ee1c46;
    font-size: 14px;
    height: 21px;
    width: 100%;
    line-height: 21px;
  }

  .boss_41 {
    border: 1px solid #d9dde2;
    border-radius: 4px;
    height: 40px;
    // margin-top: 16px;
    width: 272px;
  }
}

.boss_5 {
  margin: 2px 36px 0;
  font-size: 14px;
  height: 20px;
  line-height: 20px;

  &.active {
    color: #eb5b05;
  }

  &.active1 {
    color: #2e6bec;
  }

  &.active2 {
    color: #595dea;
  }
}

.boss_6 {
  text-align: center;
  line-height: 40px;
  background: #eb6215;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  cursor: pointer !important;
  font-weight: 500;
  height: 40px;
  width: 274px;

  // -webkit-animation: gif 1.65s infinite linear;
  // animation: gif 1.65s infinite linear;
  &.active {
    background: #eb5b05;
    color: #ffffff;
  }

  &.active1 {
    background: #2e6bec;
    color: #ffffff;
  }

  &.active2 {
    background: #595dea;
    color: #ffffff;
  }
}

@keyframes gif {
  0% {
    height: 40px;
    width: 274px;
  }

  50% {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    width: 294px;
  }

  100% {
    height: 40px;
    width: 274px;
  }
}

.el-carousel__item {
  display: flex;
  justify-content: center;
  /* position: relative; */
}

.hello {
  height: 672px;
  width: 6000px;
}

/* .dingOne {
    position: absolute;
    z-index: 2;
    bottom: 163px;
    left: 1900px;
    height: 46px;
    width: 348px;
    display: flex;
    justify-content: space-between;
    .dingWei {
      width: 154px;
      height: 100%;
      text-align: center;
      line-height: 46px;
    }
    .top {
      background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
      color: #ffffff;
    }
    .left {
      color: #eb6415;
      border: 1px solid #eb6415;
      box-sizing: border-box;
    }
  } */
// 取消轮播图按钮

// 轮播图 按钮位置
::v-deep .el-carousel__indicators--horizontal {
  bottom: 100px;
  left: 2515px;
}

// 取消轮播图按钮
// 输入框 只输入数字

::v-deep .boss_41 input::-webkit-outer-spin-button,
::v-deep .boss_41 input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep .boss_41 input[type='number'] {
  -moz-appearance: textfield;
}

::v-deep .el-input__inner:focus {
  border-color: #ee1c46;
}

::v-deep .el-carousel__container {
  height: 672px !important;
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 70px;
  height: 6px;
  background: hsla(0, 0%, 100%, 0.5);
  border: 1px solid #ffffff;
  /* border-radius: 50%; */
  opacity: 0.5;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 70px;
  height: 6px;
  background: #ffffff;
  /* border-radius: 50%; */
  opacity: 2;
}

::v-deep .el-carousel__item img {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  height: 672px;
  width: 6000px;
  margin: 0;
}

::v-deep .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

::v-deep .el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

::v-deep .el-carousel__arrow i {
  font-size: 33px;
  color: #454545;
}

::v-deep .el-carousel__arrow {
  width: 64px !important;
  height: 64px !important;
}

::v-deep .el-carousel__arrow--left {
  left: 1796px;
  display: none;
}

::v-deep .el-carousel__arrow--right {
  right: 1796px;
  display: none;
}
</style>
